/* eslint-disable max-lines-per-function */
import React from "react";
import List from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
// import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { bindTrigger, bindMenu } from "material-ui-popup-state";
import { usePopupState } from "material-ui-popup-state/hooks";
import ListItemText from "@mui/material/ListItemText";
import { uniqBy } from "lodash";
import { Button } from "components/haven-design/buttons";
import TableContext from "../context";
import { toKabobCase } from "../utils";
import { useInterestsTable } from "../interests-table/table-context";

type DropDownProps = {
  onStatusChange: (status: string, reason: string | null) => Promise<any>;
  closeMenu?: () => void;
  className?: string;
  loading: boolean;
}
const StatusOptions: React.FC<DropDownProps> = ({
  onStatusChange,
  closeMenu,
  className,
  loading,
}) => {
  const { totalSelectedInterests } = useInterestsTable();
  return (
    <TableContext.Consumer>
      {(query) => {
        if (!query?.data || query?.loading || query?.error) {
          return null;
        }

        const stages = uniqBy(query.data.interestListsById.map((x) => x.property.stages).flat().filter((stage) => stage.enabled), "name");

        return stages
          .map(({ name: status }) => (
            <MenuItem
              id={`actions-change-status-${toKabobCase(status)}`}
              key={status}
              className={className ?? ""}
              disabled={loading}
              onClick={() => {
                onStatusChange(status, null)
                  .finally(() => {
                    if (closeMenu) closeMenu();
                  });
              }}
            >
              {status} {`(${totalSelectedInterests})`}
            </MenuItem>
          ));
      }}
    </TableContext.Consumer>);
};

type Props = {
  isAvailable: boolean;
  actionsButton?: boolean;
  closeMenu?: () => void;
  onStatusChange: (status: string, reason: string | null) => Promise<any>;
  loading: boolean;
}

const ButtonMarkSelected: React.FC<Props> =
({ actionsButton, isAvailable, onStatusChange, closeMenu, loading }) => {

  const [open, setOpen] = React.useState(false);
  const popupState = usePopupState({ variant: "popover", popupId: "actions-change-status-menu" });

  const toggleMenu = () => setOpen(!open);

  if (actionsButton) {
    return (
      <>
        <MenuItem onClick={toggleMenu} style={{ flexDirection: "row" }}>
          <ListItemText primary="Change Status" />
          {open ? <ExpandLess /> : <ExpandMore />}
        </MenuItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <StatusOptions
              onStatusChange={onStatusChange}
              closeMenu={closeMenu}
              className="nested"
              loading={loading}
            />
          </List>
        </Collapse>
      </>
    );
  }
  return (
    <>
      <Button id="actions-change-status" color="secondary" {...bindTrigger(popupState)} disabled={!isAvailable || loading} style={{ height: "100%" }}>
        <span>Change&nbsp;Status&nbsp;</span> <i className="fa fa-caret-down" />
      </Button>
      <Menu {...bindMenu(popupState)}>
        <StatusOptions onStatusChange={onStatusChange} loading={loading} />
      </Menu>
    </>
  );
};

export default ButtonMarkSelected;
